import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Divider,
  Paper,
  Button,
  FormControlLabel,
  Switch,
  Tab,
  Tabs,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tooltip,
  Chip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { HexColorPicker } from 'react-colorful';
import ResetIcon from '@mui/icons-material/RestartAlt';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MessageIcon from '@mui/icons-material/Message';
import PollIcon from '@mui/icons-material/Poll';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import BusinessIcon from '@mui/icons-material/Business';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import EventIcon from '@mui/icons-material/Event';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SchoolIcon from '@mui/icons-material/School';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ArticleIcon from '@mui/icons-material/Article';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CollectionsIcon from '@mui/icons-material/Collections';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonIcon from '@mui/icons-material/Person';
import InventoryIcon from '@mui/icons-material/Inventory';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import SendIcon from '@mui/icons-material/Send';
import GetAppIcon from '@mui/icons-material/GetApp';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import DevicesIcon from '@mui/icons-material/Devices';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import BuildIcon from '@mui/icons-material/Build';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BarChartIcon from '@mui/icons-material/BarChart';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useThemeContext, DEFAULT_THEME_COLORS } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';

// Local storage anahtarları
const SIDEBAR_COLOR_KEY = 'gts_sidebar_color';
const SIDEBAR_TEXT_COLOR_KEY = 'gts_sidebar_text_color';
const SIDEBAR_AUTO_TEXT_KEY = 'gts_sidebar_auto_text';
const SIDEBAR_VISIBLE_HEADERS_KEY = 'gts_sidebar_visible_headers';
const SIDEBAR_VISIBLE_ITEMS_KEY = 'gts_sidebar_visible_items';
const SIDEBAR_EXPANDED_HEADERS_KEY = 'gts_sidebar_expanded_headers';

// Varsayılan renkler
const DEFAULT_SIDEBAR_COLOR = '#102648';
const DEFAULT_TEXT_COLOR = '#ffffff';
const SIDEBAR_SETTINGS_CHANGED_EVENT = 'gts-sidebar-settings-changed';
const TEMP_HIDDEN_HR_BUTTON_IDS = new Set([
  'leaveManagement',
  'performanceManagement',
  'trainingDevelopment',
  'payroll',
  'documentManagement',
]);

const LEGACY_ITEM_ID_TO_CANONICAL: Record<string, Record<string, string>> = {
  accounting: {
    'accounting-dashboard': 'dashboard',
    cari: 'current',
    stok: 'stock',
    banka: 'bank',
    kasa: 'cash',
    depo: 'warehouse',
    doviz: 'currency',
    'cek-senet': 'checksNotes',
    krediler: 'loans',
    projeler: 'projects',
    fatura: 'invoice',
    'e-fatura': 'eInvoice',
    teklifler: 'offers',
    irsaliyeler: 'waybills',
    siparisler: 'orders',
  },
  sales_system: {
    'hizli-satis': 'fastSale',
    restorant: 'restaurant',
    'qr-menu': 'qrMenu',
    'e-commerce': 'eCommerce',
  },
  hr: {
    'ik-izin': 'leaveManagement',
    'ik-performans': 'performanceManagement',
    'ik-egitim': 'trainingDevelopment',
    'ik-bordro': 'payroll',
    'ik-dokuman': 'documentManagement',
    'ik-isealim': 'recruitment',
  },
};

// Bileşen için tip tanımları
interface SubSection {
  id: string;
  label: string;
  icon: React.ReactNode;
  items: {
    id: string;
    label: string;
    icon: React.ReactNode;
  }[];
}

interface Section {
  id: string;
  label: string;
  icon: React.ReactNode;
  items: {
    id: string;
    label: string;
    icon: React.ReactNode;
  }[];
  subSections: SubSection[];
}

// Ana başlıklar ve alt başlıklar
const SIDEBAR_SECTIONS: Section[] = [
  {
    id: 'accounting',
    label: 'Ön Muhasebe',
    icon: <AccountBalanceWalletIcon />,
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
      { id: 'current', label: 'Cari', icon: <PersonIcon /> },
      { id: 'stock', label: 'Ürün ve Stok', icon: <InventoryIcon /> },
      { id: 'bank', label: 'Banka', icon: <AccountBalanceIcon /> },
      { id: 'cash', label: 'Kasa', icon: <LocalAtmIcon /> },
      { id: 'checksNotes', label: 'Çek/Senet', icon: <ReceiptLongIcon /> },
      { id: 'loans', label: 'Krediler', icon: <RequestQuoteIcon /> },
      { id: 'projects', label: 'Projeler', icon: <AccountTreeIcon /> },
      { id: 'invoice', label: 'Fatura', icon: <ReceiptIcon /> },
      { id: 'eInvoice', label: 'E-Fatura', icon: <DescriptionIcon /> },
      { id: 'offers', label: 'Teklifler', icon: <LocalOfferIcon /> },
      { id: 'waybills', label: 'İrsaliyeler', icon: <LocalShippingIcon /> },
      { id: 'orders', label: 'Siparişler', icon: <ShoppingCartIcon /> },
      { id: 'interCompanyB2B', label: 'B2B Siparişi', icon: <MoveToInboxIcon /> },
      { id: 'warehouse', label: 'Depo', icon: <WarehouseIcon /> },
      { id: 'currency', label: 'Döviz', icon: <CurrencyExchangeIcon /> },
      { id: 'branchPrices', label: 'Şube Fiyatları', icon: <LocalOfferIcon /> },
      { id: 'imageLibrary', label: 'Resim Kütüphanesi', icon: <CollectionsIcon /> },
    ],
    subSections: []
  },
  {
    id: 'sales_system',
    label: 'Satış Sistemi',
    icon: <StorefrontIcon />,
    items: [
      { id: 'kitchenScreen', label: 'Mutfak Ekranı', icon: <RestaurantIcon /> },
      { id: 'fastSale', label: 'Hızlı Satış', icon: <FlashOnIcon /> },
      { id: 'restaurant', label: 'Restorant', icon: <RestaurantIcon /> },
      { id: 'orderManagement', label: 'Paket Yönetimi', icon: <LocalShippingIcon /> },
      { id: 'qrMenu', label: 'QR Menü', icon: <QrCode2Icon /> },
      { id: 'kioskMenu', label: 'Kiosk Menü', icon: <TouchAppIcon /> },
      { id: 'eCommerce', label: 'E-Ticaret', icon: <ShoppingBasketIcon /> },
      { id: 'courier', label: 'Kurye', icon: <DeliveryDiningIcon /> },
      { id: 'salesReports', label: 'Raporlar', icon: <AssessmentIcon /> },
      { id: 'integrations', label: 'Entegrasyonlar', icon: <IntegrationInstructionsIcon /> },
      { id: 'haciogluMapping', label: 'Hacıoğlu Ürün Eşleştirme', icon: <CompareArrowsIcon /> },
      { id: 'imageLibrary', label: 'Resim Kütüphanesi', icon: <CollectionsIcon /> },
    ],
    subSections: []
  },
  {
    id: 'task_tracking',
    label: 'Görev Takip',
    icon: <TrackChangesIcon />,
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
      { id: 'tasks', label: 'Görevler', icon: <AssignmentIcon /> },
      { id: 'reports', label: 'Raporlar', icon: <AssessmentIcon /> },
      { id: 'messages', label: 'Mesajlar', icon: <MessageIcon /> },
      { id: 'surveys', label: 'Anketler', icon: <PollIcon /> },
    ],
    subSections: []
  },
  {
    id: 'hr',
    label: 'İnsan Kaynakları',
    icon: <SupervisedUserCircleIcon />,
    items: [
      { id: 'personnel', label: 'Personel', icon: <PeopleIcon /> },
      { id: 'shifts', label: 'Vardiya', icon: <AccessTimeIcon /> },
      { id: 'pdks', label: 'PDKS', icon: <FingerprintIcon /> },
      { id: 'leaveManagement', label: 'İzin Yönetimi', icon: <EventAvailableIcon /> },
      { id: 'performanceManagement', label: 'Performans Yönetimi', icon: <TrendingUpIcon /> },
      { id: 'trainingDevelopment', label: 'Eğitim ve Gelişim', icon: <SchoolIcon /> },
      { id: 'payroll', label: 'Bordro ve Ödemeler', icon: <RequestQuoteIcon /> },
      { id: 'documentManagement', label: 'Döküman Yönetimi', icon: <ArticleIcon /> },
      { id: 'recruitment', label: 'İşe Alım Yönetimi', icon: <PersonAddIcon /> },
      { id: 'cvApplications', label: 'İş Başvuruları', icon: <DescriptionIcon /> },
    ].filter(item => !TEMP_HIDDEN_HR_BUTTON_IDS.has(item.id)),
    subSections: []
  },
  {
    id: 'wms',
    label: 'Akıllı Depo WMS',
    icon: <WarehouseIcon />,
    items: [
      { id: 'wmsPanel', label: 'WMS Paneli', icon: <DashboardIcon /> },
      { id: 'wmsWarehouseSetup', label: 'Depo Tanımlama', icon: <WarehouseIcon /> },
      { id: 'wmsOrderPool', label: 'Sipariş Havuzu', icon: <ShoppingCartIcon /> },
      { id: 'wmsWaves', label: 'İş Emirleri', icon: <AssignmentIcon /> },
      { id: 'wmsPickingSetup', label: 'Toplama', icon: <PlaylistAddCheckIcon /> },
      { id: 'wmsCancelMgmt', label: 'İptal Yönetimi', icon: <CancelOutlinedIcon /> },
      { id: 'wmsPackingSetup', label: 'Paketleme', icon: <Inventory2Icon /> },
      { id: 'wmsReceivingSetup', label: 'Mal Kabul', icon: <MoveToInboxIcon /> },
      { id: 'wmsCycleCountSetup', label: 'Stok Sayım', icon: <FactCheckIcon /> },
      { id: 'wmsReceivingMgmt', label: 'Mal Kabul Yönetimi', icon: <LocalShippingIcon /> },
      { id: 'wmsCycleCountMgmt', label: 'Stok Sayım Yönetimi', icon: <InventoryIcon /> },
      { id: 'wmsEquipment', label: 'Ekipman Yönetimi', icon: <BuildIcon /> },
      { id: 'wmsReports', label: 'WMS Raporları', icon: <BarChartIcon /> },
    ],
    subSections: []
  },
  {
    id: 'device_management',
    label: 'Cihaz Yönetimi',
    icon: <DevicesIcon />,
    items: [
      { id: 'deviceManagement', label: 'Cihaz Yönetimi', icon: <DevicesIcon /> },
      { id: 'scales', label: 'Tartılar', icon: <MonitorWeightIcon /> },
    ],
    subSections: []
  },
  {
    id: 'card_management',
    label: 'Kart & Cüzdan',
    icon: <CreditCardIcon />,
    items: [
      { id: 'cards', label: 'Kart Tanımları', icon: <CreditCardIcon /> },
      { id: 'accessManagement', label: 'Geçiş Yönetimi', icon: <MeetingRoomIcon /> },
    ],
    subSections: []
  },
  {
    id: 'branches',
    label: 'Şubeler',
    icon: <BusinessIcon />,
    items: [
      { id: 'branches', label: 'Şubeler', icon: <BusinessIcon /> },
    ],
    subSections: []
  },
  {
    id: 'other',
    label: 'Diğer',
    icon: <EventIcon />,
    items: [
      { id: 'events', label: 'Etkinlikler', icon: <EventIcon /> },
      { id: 'reservations', label: 'Rezervasyon', icon: <EventSeatIcon /> },
      { id: 'mailReports', label: 'Otomatik Mail Raporları', icon: <MarkEmailReadIcon /> },
    ],
    subSections: []
  }
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

interface SidebarSettingsModalProps {
  open: boolean;
  onClose: () => void;
}

const SidebarSettingsModal: React.FC<SidebarSettingsModalProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  // Şirket modül kontrolü (SuperAdmin) — kapalı modüller kullanıcı tarafından açılamaz.
  const { isModuleEnabled } = useAuth();
  
  // ThemeContext'ten tema renklerini al
  const { 
    colors: themeColors, 
    setPrimaryColor, 
    setSecondaryColor, 
    setAccentColor, 
    resetToDefaults: resetThemeToDefaults 
  } = useThemeContext();

  const notifySidebarSettingsChanged = () => {
    window.dispatchEvent(new Event(SIDEBAR_SETTINGS_CHANGED_EVENT));
  };

  const normalizeSectionItems = (sectionId: string, itemIds: string[]): string[] => {
    const section = SIDEBAR_SECTIONS.find(s => s.id === sectionId);
    if (!section) return itemIds;

    const canonicalIds = new Set(section.items.map(item => item.id));
    const legacyMap = LEGACY_ITEM_ID_TO_CANONICAL[sectionId] || {};
    const normalized: string[] = [];

    itemIds.forEach((id) => {
      const canonicalId = canonicalIds.has(id) ? id : legacyMap[id];
      if (canonicalId && canonicalIds.has(canonicalId) && !normalized.includes(canonicalId)) {
        normalized.push(canonicalId);
      }
    });

    return normalized;
  };

  const normalizeVisibleItems = (items: {[key: string]: string[]}) => {
    const normalized: {[key: string]: string[]} = {};
    SIDEBAR_SECTIONS.forEach(section => {
      const source = items[section.id] ?? section.items.map(item => item.id);
      normalized[section.id] = normalizeSectionItems(section.id, source);
    });
    return normalized;
  };
  
  // Ana tab kontrolü için state
  const [mainTabValue, setMainTabValue] = useState(0);
  
  // Renk tab kontrolü için state (sidebar renkleri)
  const [colorTabValue, setColorTabValue] = useState(0);
  
  // Tema renk tab kontrolü için state
  const [themeColorTabValue, setThemeColorTabValue] = useState(0);
  
  // Sidebar rengi için state
  const [sidebarColor, setSidebarColor] = useState<string>(() => {
    return localStorage.getItem(SIDEBAR_COLOR_KEY) || DEFAULT_SIDEBAR_COLOR;
  });
  
  // Yazı rengi için state
  const [textColor, setTextColor] = useState<string>(() => {
    return localStorage.getItem(SIDEBAR_TEXT_COLOR_KEY) || DEFAULT_TEXT_COLOR;
  });
  
  // Otomatik yazı rengi için state
  const [autoTextColor, setAutoTextColor] = useState<boolean>(() => {
    const saved = localStorage.getItem(SIDEBAR_AUTO_TEXT_KEY);
    return saved ? saved === 'true' : true;
  });
  
  // Görünür ana başlıkların state'i
  const [visibleHeaders, setVisibleHeaders] = useState<string[]>(() => {
    const saved = localStorage.getItem(SIDEBAR_VISIBLE_HEADERS_KEY);
    return saved ? JSON.parse(saved) : SIDEBAR_SECTIONS.map(section => section.id);
  });
  
  // Görünür alt başlıkların state'i
  const [visibleItems, setVisibleItems] = useState<{[key: string]: string[]}>(() => {
    const saved = localStorage.getItem(SIDEBAR_VISIBLE_ITEMS_KEY);
    if (saved) {
      try {
        return normalizeVisibleItems(JSON.parse(saved));
      } catch {
        // Parse hatasinda varsayilanlara don
      }
    }
    
    // Varsayılan olarak tüm alt başlıklar görünür
    const defaultItems: {[key: string]: string[]} = {};
    SIDEBAR_SECTIONS.forEach(section => {
      defaultItems[section.id] = section.items.map(item => item.id);
      
      // Alt bölümler varsa onları da ekle
      if (section.subSections) {
        section.subSections.forEach(subsection => {
          defaultItems[subsection.id] = subsection.items.map(item => item.id);
        });
      }
    });
    
    return normalizeVisibleItems(defaultItems);
  });
  
  // Genişletilmiş ana başlıkların state'i
  const [expandedHeaders, setExpandedHeaders] = useState<string[]>(() => {
    const saved = localStorage.getItem(SIDEBAR_EXPANDED_HEADERS_KEY);
    return saved ? JSON.parse(saved) : SIDEBAR_SECTIONS.map(section => section.id);
  });
  
  // Rengin açık mı koyu mu olduğunu kontrol eden fonksiyon
  const isLightColor = (color: string): boolean => {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return yiq > 128;
  };
  
  // Rengin açık/koyu durumuna göre otomatik yazı rengi üreten fonksiyon
  const getAutoTextColor = (bgColor: string): string => {
    return isLightColor(bgColor) ? '#000000' : '#ffffff';
  };
  
  // Arka plan rengi değiştiğinde otomatik yazı rengini güncelle
  useEffect(() => {
    if (autoTextColor) {
      const newTextColor = getAutoTextColor(sidebarColor);
      setTextColor(newTextColor);
      document.documentElement.style.setProperty('--sidebar-text-color', newTextColor);
      localStorage.setItem(SIDEBAR_TEXT_COLOR_KEY, newTextColor);
    }
  }, [sidebarColor, autoTextColor]);
  
  // Ana tab değişikliği
  const handleMainTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setMainTabValue(newValue);
  };
  
  // Renk tab değişikliği
  const handleColorTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setColorTabValue(newValue);
  };
  
  // Tema renk tab değişikliği
  const handleThemeColorTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setThemeColorTabValue(newValue);
  };

  // Arka plan rengi değişikliğini kaydet ve uygula
  const handleColorChange = (color: string) => {
    setSidebarColor(color);
    localStorage.setItem(SIDEBAR_COLOR_KEY, color);
    document.documentElement.style.setProperty('--sidebar-color', color);
  };
  
  // Yazı rengi değişikliğini kaydet ve uygula
  const handleTextColorChange = (color: string) => {
    setTextColor(color);
    localStorage.setItem(SIDEBAR_TEXT_COLOR_KEY, color);
    document.documentElement.style.setProperty('--sidebar-text-color', color);
  };
  
  // Otomatik yazı rengi ayarını değiştir
  const handleAutoTextToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isAuto = event.target.checked;
    setAutoTextColor(isAuto);
    localStorage.setItem(SIDEBAR_AUTO_TEXT_KEY, String(isAuto));
    
    if (isAuto) {
      const newTextColor = getAutoTextColor(sidebarColor);
      setTextColor(newTextColor);
      document.documentElement.style.setProperty('--sidebar-text-color', newTextColor);
      localStorage.setItem(SIDEBAR_TEXT_COLOR_KEY, newTextColor);
    }
  };
  
  // Ana başlık görünürlüğünü değiştir
  const handleHeaderVisibilityChange = (headerId: string, isVisible: boolean) => {
    let newVisibleHeaders = [...visibleHeaders];
    
    if (isVisible && !newVisibleHeaders.includes(headerId)) {
      newVisibleHeaders.push(headerId);
    } else if (!isVisible && newVisibleHeaders.includes(headerId)) {
      newVisibleHeaders = newVisibleHeaders.filter(id => id !== headerId);
    }
    
    setVisibleHeaders(newVisibleHeaders);
    localStorage.setItem(SIDEBAR_VISIBLE_HEADERS_KEY, JSON.stringify(newVisibleHeaders));
    notifySidebarSettingsChanged();
    
    // CSS özelliklerini güncelle
    applyHeaderVisibilityStyles(newVisibleHeaders);
  };
  
  // Alt başlık görünürlüğünü değiştir
  const handleItemVisibilityChange = (sectionId: string, itemId: string, isVisible: boolean) => {
    let newVisibleItems = {...visibleItems};
    
    if (!newVisibleItems[sectionId]) {
      newVisibleItems[sectionId] = [];
    }
    
    if (isVisible && !newVisibleItems[sectionId].includes(itemId)) {
      newVisibleItems[sectionId].push(itemId);
    } else if (!isVisible && newVisibleItems[sectionId].includes(itemId)) {
      newVisibleItems[sectionId] = newVisibleItems[sectionId].filter(id => id !== itemId);
    }
    
    setVisibleItems(newVisibleItems);
    localStorage.setItem(SIDEBAR_VISIBLE_ITEMS_KEY, JSON.stringify(newVisibleItems));
    notifySidebarSettingsChanged();
    
    // CSS özelliklerini güncelle
    applyItemVisibilityStyles(newVisibleItems);
  };
  
  // Ana başlığı genişlet/daralt
  const toggleHeaderExpanded = (headerId: string) => {
    let newExpandedHeaders = [...expandedHeaders];
    
    if (!newExpandedHeaders.includes(headerId)) {
      newExpandedHeaders.push(headerId);
    } else {
      newExpandedHeaders = newExpandedHeaders.filter(id => id !== headerId);
    }
    
    setExpandedHeaders(newExpandedHeaders);
    localStorage.setItem(SIDEBAR_EXPANDED_HEADERS_KEY, JSON.stringify(newExpandedHeaders));
  };
  
  // Tüm ana başlıkları seç/kaldır
  const handleSelectAllHeaders = (selectAll: boolean) => {
    const newVisibleHeaders = selectAll 
      ? SIDEBAR_SECTIONS.map(section => section.id) 
      : [];
    
    setVisibleHeaders(newVisibleHeaders);
    localStorage.setItem(SIDEBAR_VISIBLE_HEADERS_KEY, JSON.stringify(newVisibleHeaders));
    notifySidebarSettingsChanged();
    
    // CSS özelliklerini güncelle
    applyHeaderVisibilityStyles(newVisibleHeaders);
  };
  
  // Belirli bir bölümün tüm alt başlıklarını seç/kaldır
  const handleSelectAllItems = (sectionId: string, selectAll: boolean) => {
    let newVisibleItems = {...visibleItems};
    let itemsList: string[] = [];
    
    // Bölüm veya alt bölüm bul
    let section = SIDEBAR_SECTIONS.find(s => s.id === sectionId);
    if (section) {
      itemsList = section.items.map(item => item.id);
    } else {
      // Alt bölüm olabilir
      for (const mainSection of SIDEBAR_SECTIONS) {
        if (mainSection.subSections) {
          const subSection = mainSection.subSections.find(sub => sub.id === sectionId);
          if (subSection) {
            itemsList = subSection.items.map(item => item.id);
            break;
          }
        }
      }
    }
    
    newVisibleItems[sectionId] = selectAll ? itemsList : [];
    setVisibleItems(newVisibleItems);
    localStorage.setItem(SIDEBAR_VISIBLE_ITEMS_KEY, JSON.stringify(newVisibleItems));
    notifySidebarSettingsChanged();
    
    // CSS özelliklerini güncelle
    applyItemVisibilityStyles(newVisibleItems);
  };
  
  // CSS stil özelliklerini uygula - ana başlıklar
  const applyHeaderVisibilityStyles = (headers: string[]) => {
    SIDEBAR_SECTIONS.forEach(section => {
      const isVisible = headers.includes(section.id);
      document.documentElement.style.setProperty(
        `--sidebar-header-${section.id}-display`, 
        isVisible ? 'flex' : 'none'
      );
    });
  };
  
  // CSS stil özelliklerini uygula - alt başlıklar
  const applyItemVisibilityStyles = (items: {[key: string]: string[]}) => {
    // Ana bölümlerdeki öğeler
    SIDEBAR_SECTIONS.forEach(section => {
      section.items.forEach(item => {
        const isVisible = items[section.id]?.includes(item.id) || false;
        document.documentElement.style.setProperty(
          `--sidebar-button-${item.id}-display`, 
          isVisible ? 'flex' : 'none'
        );
      });
      
      // Alt bölümler varsa
      if (section.subSections) {
        section.subSections.forEach(subsection => {
          subsection.items.forEach(item => {
            const isVisible = items[subsection.id]?.includes(item.id) || false;
            document.documentElement.style.setProperty(
              `--sidebar-button-${item.id}-display`, 
              isVisible ? 'flex' : 'none'
            );
          });
        });
      }
    });
  };

  // Varsayılan renklere dön
  const resetToDefault = () => {
    setSidebarColor(DEFAULT_SIDEBAR_COLOR);
    setTextColor(DEFAULT_TEXT_COLOR);
    setAutoTextColor(true);
    
    localStorage.setItem(SIDEBAR_COLOR_KEY, DEFAULT_SIDEBAR_COLOR);
    localStorage.setItem(SIDEBAR_TEXT_COLOR_KEY, DEFAULT_TEXT_COLOR);
    localStorage.setItem(SIDEBAR_AUTO_TEXT_KEY, 'true');
    
    document.documentElement.style.setProperty('--sidebar-color', DEFAULT_SIDEBAR_COLOR);
    document.documentElement.style.setProperty('--sidebar-text-color', DEFAULT_TEXT_COLOR);
  };
  
  // Buton ayarlarını sıfırla
  const resetButtonSettings = () => {
    // Tüm ana başlıkları görünür yap
    const allHeaders = SIDEBAR_SECTIONS.map(section => section.id);
    setVisibleHeaders(allHeaders);
    localStorage.setItem(SIDEBAR_VISIBLE_HEADERS_KEY, JSON.stringify(allHeaders));
    
    // Tüm alt başlıkları görünür yap
    const allItems: {[key: string]: string[]} = {};
    SIDEBAR_SECTIONS.forEach(section => {
      allItems[section.id] = section.items.map(item => item.id);
      
      if (section.subSections) {
        section.subSections.forEach(subsection => {
          allItems[subsection.id] = subsection.items.map(item => item.id);
        });
      }
    });
    
    setVisibleItems(allItems);
    localStorage.setItem(SIDEBAR_VISIBLE_ITEMS_KEY, JSON.stringify(allItems));
    
    // Tüm ana başlıkları genişletilmiş yap
    setExpandedHeaders(allHeaders);
    localStorage.setItem(SIDEBAR_EXPANDED_HEADERS_KEY, JSON.stringify(allHeaders));
    notifySidebarSettingsChanged();
    
    // CSS özelliklerini güncelle
    applyHeaderVisibilityStyles(allHeaders);
    applyItemVisibilityStyles(allItems);
  };

  // Başlangıçta tüm ayarları uygula
  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-color', sidebarColor);
    document.documentElement.style.setProperty('--sidebar-text-color', textColor);
    
    // Ana başlık görünürlük ayarlarını uygula
    applyHeaderVisibilityStyles(visibleHeaders);
    
    // Alt başlık görünürlük ayarlarını uygula
    applyItemVisibilityStyles(visibleItems);
    // Eski ID'leri normalize ettikten sonra localStorage'a geri yaz
    localStorage.setItem(SIDEBAR_VISIBLE_ITEMS_KEY, JSON.stringify(visibleItems));
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ m: 0, p: 2, bgcolor: 'var(--sidebar-color, #102648)', color: 'var(--sidebar-text-color, white)' }}>
        <Typography variant="h6">Kenar Çubuğu Ayarları</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'var(--sidebar-text-color, white)',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%', mt: 2 }}>
          {/* Ana Sekmeler */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
              value={mainTabValue} 
              onChange={handleMainTabChange} 
              aria-label="sidebar settings tabs"
              variant="fullWidth"
            >
              <Tab 
                icon={<FormatColorFillIcon />} 
                label="Sidebar" 
                id="settings-tab-0" 
                aria-controls="settings-tabpanel-0" 
              />
              <Tab 
                icon={<ColorLensIcon />} 
                label="Tema" 
                id="settings-tab-1" 
                aria-controls="settings-tabpanel-1" 
              />
              <Tab 
                icon={<VisibilityIcon />} 
                label="Butonlar" 
                id="settings-tab-2" 
                aria-controls="settings-tabpanel-2" 
              />
            </Tabs>
          </Box>
          
          {/* Renkler Sekmesi */}
          <TabPanel value={mainTabValue} index={0}>
            <FormControlLabel
              control={
                <Switch 
                  checked={autoTextColor} 
                  onChange={handleAutoTextToggle} 
                  color="primary"
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <AutoFixHighIcon sx={{ mr: 1, fontSize: 20 }} />
                  <Typography variant="body2">Otomatik Yazı Rengi</Typography>
                </Box>
              }
              sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}
            />
            
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs 
                value={colorTabValue} 
                onChange={handleColorTabChange} 
                aria-label="color settings tabs"
                variant="fullWidth"
              >
                <Tab 
                  icon={<FormatColorFillIcon />} 
                  label="Arka Plan" 
                  id="color-tab-0" 
                  aria-controls="color-tabpanel-0" 
                />
                <Tab 
                  icon={<FormatColorTextIcon />} 
                  label="Yazı Rengi" 
                  id="color-tab-1" 
                  aria-controls="color-tabpanel-1" 
                  disabled={autoTextColor}
                />
              </Tabs>
            </Box>
            
            <TabPanel value={colorTabValue} index={0}>
              <Typography variant="h6" gutterBottom>
                Kenar Çubuğu Arka Plan Rengi
              </Typography>
              <Divider sx={{ mb: 2 }} />
              
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, alignItems: 'center' }}>
                <Box sx={{ width: '100%', maxWidth: 300 }}>
                  <HexColorPicker color={sidebarColor} onChange={handleColorChange} />
                </Box>
                
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                  <Paper 
                    elevation={3} 
                    sx={{ 
                      height: 80, 
                      width: '100%', 
                      bgcolor: sidebarColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: textColor,
                      borderRadius: 1
                    }}
                  >
                    <Typography variant="body2">
                      {sidebarColor.toUpperCase()}
                    </Typography>
                  </Paper>
                </Box>
              </Box>
            </TabPanel>
            
            <TabPanel value={colorTabValue} index={1}>
              <Typography variant="h6" gutterBottom>
                Kenar Çubuğu Yazı Rengi
              </Typography>
              <Divider sx={{ mb: 2 }} />
              
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, alignItems: 'center' }}>
                <Box sx={{ width: '100%', maxWidth: 300 }}>
                  <HexColorPicker color={textColor} onChange={handleTextColorChange} />
                </Box>
                
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                  <Paper 
                    elevation={3} 
                    sx={{ 
                      height: 80, 
                      width: '100%', 
                      bgcolor: sidebarColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: textColor,
                      borderRadius: 1
                    }}
                  >
                    <Typography variant="body2">
                      {textColor.toUpperCase()}
                    </Typography>
                  </Paper>
                </Box>
              </Box>
            </TabPanel>
            
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button 
                variant="outlined" 
                color="primary" 
                onClick={resetToDefault}
                startIcon={<ResetIcon />}
              >
                Varsayılan Renklere Dön
              </Button>
            </Box>
          </TabPanel>
          
          {/* Tema Renkleri Sekmesi */}
          <TabPanel value={mainTabValue} index={1}>
            <Typography variant="h6" gutterBottom>
              Uygulama Tema Renkleri
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Butonlar, ikonlar ve diğer arayüz elemanlarının renklerini özelleştirin.
            </Typography>
            <Divider sx={{ mb: 2 }} />
            
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
              <Tabs 
                value={themeColorTabValue} 
                onChange={handleThemeColorTabChange} 
                aria-label="theme color tabs"
                variant="fullWidth"
              >
                <Tab label="Primary" id="theme-tab-0" />
                <Tab label="Secondary" id="theme-tab-1" />
                <Tab label="Accent" id="theme-tab-2" />
              </Tabs>
            </Box>
            
            {/* Primary Renk */}
            <TabPanel value={themeColorTabValue} index={0}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, alignItems: 'center' }}>
                <Box sx={{ width: '100%', maxWidth: 300 }}>
                  <HexColorPicker color={themeColors.primary} onChange={setPrimaryColor} />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                  <Paper 
                    elevation={3} 
                    sx={{ 
                      height: 80, 
                      width: '100%', 
                      bgcolor: themeColors.primary,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#ffffff',
                      borderRadius: 1
                    }}
                  >
                    <Typography variant="body2">
                      {themeColors.primary.toUpperCase()}
                    </Typography>
                  </Paper>
                  <Typography variant="caption" color="text.secondary">
                    Ana butonlar, başlıklar ve vurgular için kullanılır.
                  </Typography>
                </Box>
              </Box>
            </TabPanel>
            
            {/* Secondary Renk */}
            <TabPanel value={themeColorTabValue} index={1}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, alignItems: 'center' }}>
                <Box sx={{ width: '100%', maxWidth: 300 }}>
                  <HexColorPicker color={themeColors.secondary} onChange={setSecondaryColor} />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                  <Paper 
                    elevation={3} 
                    sx={{ 
                      height: 80, 
                      width: '100%', 
                      bgcolor: themeColors.secondary,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#ffffff',
                      borderRadius: 1
                    }}
                  >
                    <Typography variant="body2">
                      {themeColors.secondary.toUpperCase()}
                    </Typography>
                  </Paper>
                  <Typography variant="caption" color="text.secondary">
                    İkincil butonlar ve yardımcı öğeler için kullanılır.
                  </Typography>
                </Box>
              </Box>
            </TabPanel>
            
            {/* Accent Renk */}
            <TabPanel value={themeColorTabValue} index={2}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3, alignItems: 'center' }}>
                <Box sx={{ width: '100%', maxWidth: 300 }}>
                  <HexColorPicker color={themeColors.accent} onChange={setAccentColor} />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                  <Paper 
                    elevation={3} 
                    sx={{ 
                      height: 80, 
                      width: '100%', 
                      bgcolor: themeColors.accent,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#ffffff',
                      borderRadius: 1
                    }}
                  >
                    <Typography variant="body2">
                      {themeColors.accent.toUpperCase()}
                    </Typography>
                  </Paper>
                  <Typography variant="caption" color="text.secondary">
                    Bilgi mesajları ve vurgular için kullanılır.
                  </Typography>
                </Box>
              </Box>
            </TabPanel>
            
            {/* Önizleme Kartları */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle2" gutterBottom>
                Önizleme
              </Typography>
              <Paper elevation={1} sx={{ p: 2, bgcolor: 'grey.50' }}>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                  <Button variant="contained" sx={{ bgcolor: themeColors.primary }}>
                    Primary Buton
                  </Button>
                  <Button variant="contained" sx={{ bgcolor: themeColors.secondary }}>
                    Secondary Buton
                  </Button>
                  <Button variant="outlined" sx={{ borderColor: themeColors.accent, color: themeColors.accent }}>
                    Accent Buton
                  </Button>
                </Box>
              </Paper>
            </Box>
            
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button 
                variant="outlined" 
                color="primary" 
                onClick={resetThemeToDefaults}
                startIcon={<ResetIcon />}
              >
                Varsayılan Tema Renklerine Dön
              </Button>
            </Box>
          </TabPanel>
          
          {/* Butonlar Sekmesi */}
          <TabPanel value={mainTabValue} index={2}>
            <Typography variant="h6" gutterBottom>
              Kenar Çubuğu Buton Ayarları
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Kenar çubuğunda gösterilecek başlıkları ve butonları seçin.
            </Typography>
            <Divider sx={{ mb: 2 }} />
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Button 
                variant="outlined" 
                size="small" 
                onClick={() => handleSelectAllHeaders(true)}
              >
                Tümünü Seç
              </Button>
              <Button 
                variant="outlined" 
                size="small" 
                onClick={() => handleSelectAllHeaders(false)}
              >
                Tümünü Kaldır
              </Button>
            </Box>
            
            <List sx={{ bgcolor: 'background.paper' }}>
              {SIDEBAR_SECTIONS.map((section) => {
                // Şirket modül kontrolü: kapalı modüller kullanıcı tarafından açılamaz
                const moduleEnabled = isModuleEnabled(section.id);
                return (
                <React.Fragment key={section.id}>
                  <ListItem 
                    sx={{ 
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                      borderLeft: `4px solid ${theme.palette.primary.main}`,
                      mb: 1,
                      opacity: moduleEnabled ? 1 : 0.5
                    }}
                  >
                    <ListItemIcon>
                      {section.icon}
                    </ListItemIcon>
                    <ListItemText primary={section.label} />
                    {!moduleEnabled && (
                      <Tooltip title="Bu modül paketinizde bulunmuyor. Açmak için satış ekibimizle iletişime geçin.">
                        <Chip label="Pakette yok" size="small" color="warning" variant="outlined" sx={{ mr: 1 }} />
                      </Tooltip>
                    )}
                    <Checkbox
                      edge="end"
                      checked={moduleEnabled && visibleHeaders.includes(section.id)}
                      disabled={!moduleEnabled}
                      onChange={(e) => handleHeaderVisibilityChange(section.id, e.target.checked)}
                      inputProps={{ 'aria-labelledby': `header-toggle-${section.id}` }}
                    />
                    <IconButton 
                      onClick={() => toggleHeaderExpanded(section.id)}
                      sx={{ ml: 1 }}
                    >
                      {expandedHeaders.includes(section.id) ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                  </ListItem>
                  
                  <Collapse in={expandedHeaders.includes(section.id)} timeout="auto" unmountOnExit>
                    <Box sx={{ ml: 4, mb: 2 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, mt: 1 }}>
                        <Button 
                          variant="text" 
                          size="small" 
                          onClick={() => handleSelectAllItems(section.id, true)}
                        >
                          Tümünü Seç
                        </Button>
                        <Button 
                          variant="text" 
                          size="small" 
                          onClick={() => handleSelectAllItems(section.id, false)}
                        >
                          Tümünü Kaldır
                        </Button>
                      </Box>
                      
                      <List disablePadding>
                        {section.items.map((item) => (
                          <ListItem key={item.id} sx={{ pl: 1 }} dense>
                            <ListItemIcon sx={{ minWidth: 36 }}>
                              {item.icon}
                            </ListItemIcon>
                            <ListItemText 
                              primary={item.label} 
                              primaryTypographyProps={{ fontSize: '0.9rem' }}
                            />
                            <Checkbox
                              edge="end"
                              checked={visibleItems[section.id]?.includes(item.id) || false}
                              onChange={(e) => handleItemVisibilityChange(section.id, item.id, e.target.checked)}
                              inputProps={{ 'aria-labelledby': `item-toggle-${item.id}` }}
                            />
                          </ListItem>
                        ))}
                      </List>
                      
                      {/* Alt bölümler varsa */}
                      {section.subSections?.map((subsection) => (
                        <React.Fragment key={subsection.id}>
                          <ListItem 
                            sx={{ 
                              mt: 2,
                              bgcolor: 'rgba(0, 0, 0, 0.02)',
                              borderLeft: `2px solid ${theme.palette.secondary.main}`
                            }}
                            dense
                          >
                            <ListItemIcon sx={{ minWidth: 36 }}>
                              {subsection.icon}
                            </ListItemIcon>
                            <ListItemText 
                              primary={subsection.label} 
                              primaryTypographyProps={{ fontWeight: 'medium' }}
                            />
                            {subsection.items.length > 0 && (
                              <Box sx={{ display: 'flex' }}>
                                <Button 
                                  variant="text" 
                                  size="small" 
                                  onClick={() => handleSelectAllItems(subsection.id, true)}
                                >
                                  Tümü
                                </Button>
                                <Button 
                                  variant="text" 
                                  size="small" 
                                  onClick={() => handleSelectAllItems(subsection.id, false)}
                                >
                                  Hiçbiri
                                </Button>
                              </Box>
                            )}
                          </ListItem>
                          
                          {subsection.items.length > 0 && (
                            <List disablePadding sx={{ ml: 2 }}>
                              {subsection.items.map((item) => (
                                <ListItem key={item.id} sx={{ pl: 1 }} dense>
                                  <ListItemIcon sx={{ minWidth: 36 }}>
                                    {item.icon}
                                  </ListItemIcon>
                                  <ListItemText 
                                    primary={item.label} 
                                    primaryTypographyProps={{ fontSize: '0.85rem' }}
                                  />
                                  <Checkbox
                                    edge="end"
                                    checked={visibleItems[subsection.id]?.includes(item.id) || false}
                                    onChange={(e) => handleItemVisibilityChange(subsection.id, item.id, e.target.checked)}
                                    inputProps={{ 'aria-labelledby': `subitem-toggle-${item.id}` }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          )}
                        </React.Fragment>
                      ))}
                    </Box>
                  </Collapse>
                </React.Fragment>
                );
              })}
            </List>
            
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button 
                variant="outlined" 
                color="primary" 
                onClick={resetButtonSettings}
                startIcon={<ResetIcon />}
              >
                Varsayılan Ayarlara Dön
              </Button>
            </Box>
          </TabPanel>
          
          <Typography variant="body2" sx={{ mt: 3, color: 'text.secondary' }}>
            Not: Değişiklikler otomatik olarak kaydedilir ve uygulanır.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SidebarSettingsModal; 